import type { ProviderMatcher } from '../widgetMacroTypes.ts';

import { withUnit } from '../utils/urlMatcherUtils.ts';

const MATCH_URL = 'wufoo.com';
const PATTERN = /http:\/\/([^.]+)\.wufoo\.com\/([^/]+)\/([^/]+)/;

const DEFAULT_WIDTH = '100%';
const DEFAULT_HEIGHT = '500px';

export const matchWufoo: ProviderMatcher = (url, params) => {
	if (!url.includes(MATCH_URL)) {
		return null;
	}
	const match = PATTERN.exec(url);
	if (!match) {
		return null;
	}
	const userId = match[1];
	const type = match[2];
	const id = match[3];
	const embedUrl =
		type === 'reports'
			? `//${userId}.wufoo.com/reports/${id}/`
			: `//${userId}.wufoo.com/embed/${id}/`;
	return {
		kind: 'iframe',
		provider: 'Wufoo',
		embedUrl,
		width: withUnit(params.width) ?? DEFAULT_WIDTH,
		height: withUnit(params.height) ?? DEFAULT_HEIGHT,
	};
};
